import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

let activeDropdownId = null;

registerComponent(
  "filters-desktop",
  class FiltersDesktop extends WYATTElement {
    SELECTORS = {
      filterItem: "[data-filter-item]",
      filterToggle: "[data-filter-toggle]",
      filterDropdown: "[data-filter-dropdown]",
    };

    CLASSES = {
      active: "is-active",
    };

    ATTRIBUTES = {
      dropdownId: "data-filter-dropdown",
    };

    constructor() {
      super();

      this.handleClick = this.handleClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.documentClickBound = false;

      this.toggles = this.querySelectorAll(this.SELECTORS.filterToggle);
      this.toggles.forEach((toggle) => {
        toggle.addEventListener("click", this.handleClick);
      });

      this.subscribe(WYATT.PubSub.events.filtersUpdated, () => {
        this.reopenActiveDropdown();
      });

      this.reopenActiveDropdown();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.documentClickBound) {
        document.removeEventListener("click", this.handleDocumentClick);
      }
    }

    open(filterItem) {
      this.querySelectorAll(this.SELECTORS.filterItem).forEach((item) => {
        if (item !== filterItem) {
          const dropdown = item.querySelector(this.SELECTORS.filterDropdown);
          if (!dropdown.hasAttribute("hidden")) {
            this.close(item);
          }
        }
      });

      const toggle = filterItem.querySelector(this.SELECTORS.filterToggle);
      const dropdown = filterItem.querySelector(this.SELECTORS.filterDropdown);

      dropdown.removeAttribute("hidden");
      toggle.setAttribute("aria-expanded", "true");
      toggle.classList.add(this.CLASSES.active);
      activeDropdownId = dropdown.getAttribute(this.ATTRIBUTES.dropdownId);

      if (!this.documentClickBound) {
        document.addEventListener("click", this.handleDocumentClick);
        this.documentClickBound = true;
      }
    }

    close(filterItem) {
      const toggle = filterItem.querySelector(this.SELECTORS.filterToggle);
      const dropdown = filterItem.querySelector(this.SELECTORS.filterDropdown);

      dropdown.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", "false");
      toggle.classList.remove(this.CLASSES.active);
      const dropdownId = dropdown.getAttribute(this.ATTRIBUTES.dropdownId);
      if (activeDropdownId === dropdownId) {
        activeDropdownId = null;
      }

      const hasOpenDropdown = Array.from(
        this.querySelectorAll(this.SELECTORS.filterDropdown),
      ).some((dd) => !dd.hasAttribute("hidden"));

      if (!hasOpenDropdown && this.documentClickBound) {
        document.removeEventListener("click", this.handleDocumentClick);
        this.documentClickBound = false;
      }
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const toggleButton = event.target.closest(this.SELECTORS.filterToggle);
      if (!toggleButton) return;

      const filterItem = toggleButton.closest(this.SELECTORS.filterItem);
      const dropdown = filterItem.querySelector(this.SELECTORS.filterDropdown);

      const isOpen = !dropdown.hasAttribute("hidden");
      if (isOpen) {
        this.close(filterItem);
      } else {
        this.open(filterItem);
      }
    }

    handleDocumentClick(event) {
      const isClickOnToggle = event.target.closest(this.SELECTORS.filterToggle);
      const isClickInDropdown = event.target.closest(
        this.SELECTORS.filterDropdown,
      );

      if (!isClickOnToggle && !isClickInDropdown) {
        this.querySelectorAll(this.SELECTORS.filterItem).forEach((item) => {
          const dropdown = item.querySelector(this.SELECTORS.filterDropdown);
          if (!dropdown.hasAttribute("hidden")) {
            this.close(item);
          }
        });
      }
    }

    reopenActiveDropdown() {
      if (!activeDropdownId) return;

      const activeDropdown = this.querySelector(
        `[${this.ATTRIBUTES.dropdownId}="${activeDropdownId}"]`,
      );
      const activeFilterItem = activeDropdown?.closest(
        this.SELECTORS.filterItem,
      );

      if (activeFilterItem) {
        this.open(activeFilterItem);
      }
    }
  },
);
